<template>
  <div>
    <game></game>
    <lottery-popup></lottery-popup>
    <receive-coupon></receive-coupon>
    <prize-popup></prize-popup>
  </div>
</template>
<script>
import Game from '@this/connect/List/Game';
import LotteryPopup from '@this/connect/Popup/LotteryPopup';
import ReceiveCoupon from '@this/connect/Popup/ReceiveCoupon';
import PrizePopup from '@this/connect/Popup/PrizePopup';
export default {
  components: {
    Game,
    LotteryPopup,
    ReceiveCoupon,
    PrizePopup,
  },
};
</script>
<style lang="scss" scoped></style>
